import { DailyRewardPackageCode } from 'config/constants/dailyReward'
import { DailyRewardPackage } from 'config/types/bonus/DailyReward'
import { ColumnCenter } from 'layout/Components/Column'
import React, { useMemo, useState } from 'react'
import { useDailyRewardCampaign, useTodayRewards } from 'state/bonus/hooks/dailyReward'
import styled, { css } from 'styled-components'
import theme from 'theme'
import AlchemyModal, { ModalBody, ModalFooter, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import Box from 'UIKit/Box/Box'
import { formatDisplayDate } from 'utils/dateHelper'
import DailyCheckinAction from '../component/DailyCheckinAction'
import DailyCheckinInfomation from '../component/DailyCheckinInfomation'
import DailyCheckinRewards from '../component/DailyCheckinRewards'
import PackageTabs from './PackageTabs'

const MODAL_COLOR_THEME = 'darkblue'

const DailyCheckinCampaignModal: React.FC<ModalProps> = ({ onDismiss }) => {
  const { campaign } = useDailyRewardCampaign()

  const { currentRewards } = useTodayRewards()

  const parsedPackages = useMemo((): (DailyRewardPackage & { isWaitingClaim: boolean })[] => {
    return campaign?.packages.map((item) => {
      const isCompletedPackages = item.rewards[item.rewards.length - 1]?.userData?.isClaimed

      return {
        ...item,
        isWaitingClaim: isCompletedPackages
          ? false
          : currentRewards.find((reward) => reward.packageCode === item.code).isWaitingClaim,
      }
    })
  }, [currentRewards, campaign])

  const selectedPackageWaitingClaim = useMemo(() => {
    return (
      parsedPackages &&
      (parsedPackages.find((item) => item.isWaitingClaim)?.code ||
        parsedPackages.find((item) => !item.isTodayClaimed)?.code ||
        parsedPackages[0].code)
    )
  }, [parsedPackages])

  const [selectedPackageCode, setSelectedPackageCode] = useState<DailyRewardPackageCode>(selectedPackageWaitingClaim)

  const rewardNumberOfPackage = useMemo(() => {
    return campaign?.packages.find((item) => item.code === selectedPackageCode).rewards.length
  }, [selectedPackageCode])

  const isDisplayTabs = parsedPackages?.length > 1
  const isCustomBackground = selectedPackageCode === DailyRewardPackageCode.Mega

  return (
    <StyledModal onDismiss={onDismiss} colorTheme={MODAL_COLOR_THEME} isCustomBackground={isCustomBackground}>
      <ModalHeader colorTheme={MODAL_COLOR_THEME} />
      <ModalBody pt="0px !important">
        <ColumnCenter>
          <DailyCheckinInfomation
            rewardNumberOfPackage={rewardNumberOfPackage}
            finishTime={formatDisplayDate(new Date((campaign?.finishAt || 0) * 1000))}
          />

          {isDisplayTabs && (
            <PackageTabs
              activeCode={selectedPackageCode}
              onChange={setSelectedPackageCode}
              parsedPackages={parsedPackages}
            />
          )}

          <Box mt={theme.spacing.fix_200} width="100%">
            <DailyCheckinRewards packageCode={selectedPackageCode} />
          </Box>
        </ColumnCenter>
      </ModalBody>

      <ModalFooter>
        <DailyCheckinAction packageCode={selectedPackageCode} />
      </ModalFooter>
    </StyledModal>
  )
}

const StyledModal = styled(AlchemyModal)<{ isCustomBackground: boolean }>`
  ${({ isCustomBackground }) =>
    isCustomBackground &&
    css`
      background-image: url('/images/dailyCheckin/mega-background.png');
      background-color: none;
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    `}
`

export default DailyCheckinCampaignModal
